// extracted by mini-css-extract-plugin
export default {"header":"Profile_header__zIbVe","container":"Profile_container__YQvnj","content":"Profile_content__7LOd-"};